import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import * as fromStore from '../store';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ThemesGuard {
  private store = inject(Store);

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getThemesLoaded).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.LoadThemes());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
